import React from 'react';
import PropTypes from 'prop-types';
import { injectStripe } from 'react-stripe-elements';
import CardSection from './CardSection';

function CheckoutForm({
  orderHandler,
  loadingHandler,
  elements,
  stripe,
  setSaveCard,
}) {
  const handleSubmit = async ev => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    ev.preventDefault();

    // See our confirmCardPayment documentation for more:
    // Old https://stripe.com/docs/stripe-js/reference#stripe-confirm-card-payment
    // New https://stripe.com/docs/js/payment_methods/create_payment_method

    loadingHandler();
    try {
      const result = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement('card'),
      });
      orderHandler(result.paymentMethod.id);
    } catch (err) {
      orderHandler(err);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <CardSection />
      <label
        htmlFor="saveCard"
        className="mt-4 flex items-start gap-2.5 text-sm text-gray-500 cursor-pointer"
      >
        <input
          className="mt-0.5 w-4 h-4 rounded accent-panda-red flex-shrink-0"
          type="checkbox"
          id="saveCard"
          onChange={() => setSaveCard(prev => !prev)}
        />
        <span>
          By checking this box you agree to save your card for later. This
          will speed up your checkout process.
        </span>
      </label>
      <button
        className="mt-5 w-full py-3.5 px-4 rounded-xl bg-gradient-to-r from-panda-red to-panda-dark hover:from-panda-dark hover:to-panda-dark text-white font-heading font-bold text-sm shadow-md shadow-panda-red/30 active:scale-98 transition-all"
        type="submit"
      >
        Save Payment Method
      </button>
    </form>
  );
}

CheckoutForm.propTypes = {
  orderHandler: PropTypes.func,
  loadingHandler: PropTypes.func,
  setSaveCard: PropTypes.func,
  stripe: PropTypes.shape({
    createPaymentMethod: PropTypes.func,
  }).isRequired,
  elements: PropTypes.shape({
    getElement: PropTypes.func,
  }).isRequired,
};

CheckoutForm.defaultProps = {
  orderHandler: () => {},
  loadingHandler: () => {},
  setSaveCard: () => {},
};
export default injectStripe(CheckoutForm);
